import React from 'react';
import clsx from 'clsx';
import Card from './Card.jsx';

export default function EmptyState({
  icon,
  title = 'No Data',
  description,
  message,
  action,
  primaryAction,
  secondaryAction,
  variant = 'default',
  compact = false,
  className,
}) {
  const resolvedDescription = description ?? message ?? 'There is nothing to show here yet.';
  const resolvedPrimaryAction = primaryAction ?? action;

  const variantClasses = {
    default: 'border-gray-200 bg-white',
    table: 'border-dashed border-gray-300 bg-gray-50',
    search: 'border-sky-200 bg-sky-50',
    permission: 'border-amber-200 bg-amber-50',
    error: 'border-rose-200 bg-rose-50',
  };

  const toneClass = variantClasses[variant] || variantClasses.default;

  return (
    <Card
      className={clsx(
        'text-center',
        compact ? 'p-4 md:p-5' : 'p-8 md:p-12',
        toneClass,
        className
      )}
      padding="none"
      shadow="none"
    >
      {icon ? (
        <div
          className={clsx(
            'mb-4 flex justify-center text-gray-400',
            compact ? 'text-3xl' : 'text-5xl'
          )}
          aria-hidden="true"
        >
          {icon}
        </div>
      ) : null}
      <h3 className={clsx('font-ui font-semibold text-gray-800', compact ? 'text-base' : 'text-lg')}>
        {title}
      </h3>
      <p className={clsx('font-body text-gray-600', compact ? 'mt-1 text-sm' : 'mt-2 text-sm md:text-base')}>
        {resolvedDescription}
      </p>
      {resolvedPrimaryAction || secondaryAction ? (
        <div className={clsx('flex items-center justify-center gap-2', compact ? 'mt-4' : 'mt-6')}>
          {secondaryAction ? <div>{secondaryAction}</div> : null}
          {resolvedPrimaryAction ? <div>{resolvedPrimaryAction}</div> : null}
        </div>
      ) : null}
    </Card>
  );
}
